<form nz-form [formGroup]="stateForm" class="state-form">
  <nz-form-item>
    <nz-form-label [nzSpan]="24" nzRequired>State Name</nz-form-label>
    <nz-form-control style="width: 100%;" nzErrorTip="Please input the state name!">
      <nz-select formControlName="name" placeholder="Enter state name" [nzDisabled]="initialState !== null">
        <nz-option *ngFor="let state of stateOptions" [nzLabel]="state" [nzValue]="state"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <!-- <nz-form-control [nzSpan]="14"> -->
  <nz-form-item>
    <nz-form-label [nzSpan]="24" nzRequired>Providers</nz-form-label>
    <nz-form-control style="width: 100%;" nzErrorTip="Please enter at least one provider!">
      <nz-select formControlName="providers" nzMode="tags" nzPlaceHolder="Enter providers">
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  <!-- </nz-form-control> -->

  <!-- <nz-form-control [nzSpan]="14"> -->
  <nz-form-item>
    <nz-form-label [nzSpan]="24" nzRequired>Color</nz-form-label>
    <nz-form-control style="width: 100%;" nzErrorTip="Please select a color!">
      <nz-input-group [nzSuffix]="colorPreview">
        <input nz-input formControlName="color" type="color" />
      </nz-input-group>
      <ng-template #colorPreview>
        <div class="color-preview" [style.background-color]="stateForm.get('color')?.value"></div>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
  <!-- </nz-form-control> -->

  <!-- <nz-form-item>
    <nz-form-control [nzSpan]="24">
      <button nz-button nzType="primary" [disabled]="!stateForm.valid" (click)="submitForm()">Submit</button>
    </nz-form-control>
  </nz-form-item> -->
</form>
